import { render, staticRenderFns } from "./DatesBoard.vue?vue&type=template&id=0e085f78&scoped=true&"
import script from "./DatesBoard.vue?vue&type=script&lang=js&"
export * from "./DatesBoard.vue?vue&type=script&lang=js&"
import style0 from "./DatesBoard.vue?vue&type=style&index=0&id=0e085f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e085f78",
  null
  
)

export default component.exports